module.exports = __webpack_public_path__ + "img/remedation.81fe4deb.png";